<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <!--<action-button type="save" @click="save" />
                <action-button
                    type="delete"
                    @click="del(educationprogram.id)"
                    v-if="$can('educationprogram-delete')"
                />-->
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="educationprogram.name"
                  v-model="educationprogram.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('educationprograms.name')"
                  :error-messages="errors.collect('educationprogram.name')"
                  :disabled="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="educationprogram.code"
                  v-model="educationprogram.code"
                  :label="$t('educationprograms.code')"
                  :error-messages="errors.collect('educationprogram.code')"
                  :disabled="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="date_valid_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="educationprogram.date_valid"
                      v-model="computedDateValid"
                      :label="$t('educationprograms.date_valid')"
                      class="required-field"
                      v-validate="'required|validDate'"
                      :error-messages="errors.collect('educationprogram.date_valid')"
                      append-icon="event"
                      @click:append="date_valid_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      :disabled="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="educationprogram.date_valid"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                    :disabled="true"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="date_valid_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="educationprogram.status"
                  v-model="educationprogram.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_education_program_status()"
                  :label="$t('educationprograms.status')"
                  :error-messages="errors.collect('educationprogram.status')"
                  clearable
                  :disabled="true"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EducationProgramForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      educationprogram: {
        has_locale: false
      },

      date_valid_menu: false,

      dictionary: {
        attributes: {
          "educationprogram.name": this.$t("educationprograms.name"),
          "educationprogram.status": this.$t("educationprograms.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.educationprogram, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedDateValid: {
      get() {
        return this.$dateFormatGetter(this.educationprogram.date_valid)
      },
      set(val) {
        this.$set(this.educationprogram, "date_valid", this.$dateFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.educationprogram = {
        has_locale: false,
        status: this.$getDefaultDropdown(this.$dd_customer_group_status())
      }

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.educationprogram))

      this.setPageTitle()
    } else {
      this.title = this.$t("educationprograms.update_title")

      axios
        .get(this.API_URL + "educationprogram/" + this.id)
        .then((res) => {
          this.educationprogram = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.educationprogram))

          this.setPageTitle()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.educationprogram, "id")) {
        this.page_title = this.$t("educationprograms.edit_educationprogram", {
          name: this.educationprogram.name
        })
      } else {
        this.page_title = this.$t("educationprograms.new_educationprogram")
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.educationprogram.id) {
              // Create
              axios
                .post(this.API_URL + "educationprogram", {
                  name: this.educationprogram.name,
                  date_valid: this.educationprogram.date_valid,
                  status: this.educationprogram.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.educationprogram = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.educationprogram))
                      vm.setPageTitle()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/educationprograms/edit/${vm.educationprogram.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "educationprogram", {
                  id: this.educationprogram.id,
                  name: this.educationprogram.name,
                  date_valid: this.educationprogram.date_valid,
                  status: this.educationprogram.status
                })
                .then((res) => {
                  vm.educationprogram = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.educationprogram))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "educationprogram/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/educationprograms")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
